import Vue from 'vue';
import Router from 'vue-router';
import Map from './pages/Map'
import ModelCourse from './pages/ModelCourse'
import Notice from './pages/Notice'
import Policy from './pages/Policy'
import Terms from './pages/Terms'


Vue.use(Router);

export default new Router({
  base: '/chofu/',
  routes: [
    {
      path: '/',
      component: Map,
      name: 'root'
    },
    {
      path: '/:lang',
      component: Map,
      name: 'top'
    },
    {
      path: '/:lang/current/',
      component: Map,
      name: 'current'
    },
    {
      path: '/:lang/notice',
      component: Notice,
      name: 'notice'
    },
    {
      path: '/:lang/courses',
      component: ModelCourse,
      name: 'modelCourse'
    },
    {
      path: '/:lang/tag/:tagId',
      component: Map,
      name: 'mapTag'
    },
    {
      path: '/:lang/:poiId?',
      component: Map,
      name: 'map'
    },
    {
      path: '/:lang/policy',
      component: Policy,
      name: 'policy'
    },
    {
      path: '/:lang/terms',
      component: Terms,
      name: 'terms'
    },
  ],
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});
